import { InjectionToken } from '@angular/core';

export function windowFactory() {
    return window;
}

export const WINDOW = new InjectionToken<Window>('Global window token', { providedIn: 'root', factory: windowFactory });
